import { OrderStatus } from '@shared/model/order';
import { TagProps } from '@shared/ui/tag/types';
import { IOption } from '@vtbhome/juicyfront/types';

export const STATUS_MAP: Partial<Record<OrderStatus, TagProps>> = {
    completed: {
        variant: 'green',
        children: 'Приобретено',
    },
    on_payment: {
        variant: 'yellow',
        children: 'Ожидает оплаты',
    },
    order_reject: {
        variant: 'declined',
        children: 'Отклонено',
    },
    order_forming: {
        variant: 'grey',
        children: 'Создано',
    },
};

export const ORDER_STATUS_OPTIONS: IOption[] = [
    {
        label: 'Приобретено',
        value: OrderStatus.Completed,
    },
    {
        label: 'Ожидает оплаты',
        value: OrderStatus.OnPayment,
    },
    {
        label: 'Отклонено',
        value: OrderStatus.OrderReject,
    },
    {
        label: 'Создано',
        value: OrderStatus.OrderForming,
    },
];

export const ADMIN_ORDER_STATUS_OPTIONS: IOption[] = [
    {
        label: 'Приобретено',
        value: OrderStatus.Completed,
    },
    {
        label: 'Ожидает оплаты',
        value: OrderStatus.OnPayment,
    },
    {
        label: 'Отклонено',
        value: OrderStatus.OrderReject,
    },
];
